import { AddPaymentMethodCTA } from "./ctas";
export var AddPaymentMethodIA = function AddPaymentMethodIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return ADD_PAYMENT_METHOD(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [ADD_PAYMENT_METHOD_EXPLANATION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(_context) {
        return AddPaymentMethodCTA(strictLocalize).label;
      },
      linkBuilder: function linkBuilder(_context) {
        var _AddPaymentMethodCTA$, _AddPaymentMethodCTA;
        return (_AddPaymentMethodCTA$ = (_AddPaymentMethodCTA = AddPaymentMethodCTA(strictLocalize)).getLink) === null || _AddPaymentMethodCTA$ === void 0 ? void 0 : _AddPaymentMethodCTA$.call(_AddPaymentMethodCTA);
      }
    }
  };
};
var ADD_PAYMENT_METHOD = function ADD_PAYMENT_METHOD(strictLocalize) {
  return strictLocalize({
    id: "vUmmzL",
    defaultMessage: [{
      "type": 0,
      "value": "Adicionar formas de pagamento"
    }]
  });
};
var ADD_PAYMENT_METHOD_EXPLANATION = function ADD_PAYMENT_METHOD_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "9bCwIn",
    defaultMessage: [{
      "type": 0,
      "value": "Pode adicionar outras formas de pagamento clicando no botão abaixo. Para referência futura, esta opção está localizada no separador Definições no menu pendente Conta."
    }]
  });
};